var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.516,
    height: 45.607,
    viewBox: "0 0 45.516 45.607",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #36c5f0;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #2eb67d;\n      }\n\n      .cls-3 {\n        fill: #ecb22e;\n      }\n\n      .cls-4 {\n        fill: #e01e5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slack-new-logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4387",
    "data-name": "Path 4387",
    className: "cls-1",
    d: "M16.688,0a4.56,4.56,0,0,0,0,9.119h4.552V4.562A4.559,4.559,0,0,0,16.688,0h0m0,12.162H4.552a4.561,4.561,0,0,0,0,9.121H16.688a4.561,4.561,0,0,0,0-9.121Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4388",
    "data-name": "Path 4388",
    className: "cls-2",
    d: "M1326.64,16.722a4.552,4.552,0,1,0-9.1,0v4.562h4.552A4.557,4.557,0,0,0,1326.64,16.722Zm-12.138,0V4.56a4.551,4.551,0,1,0-9.1,0V16.722a4.551,4.551,0,1,0,9.1,0Z",
    transform: "translate(-1281.125 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    "data-name": "Path 4389",
    className: "cls-3",
    d: "M1309.852,1329.185a4.56,4.56,0,0,0,0-9.12H1305.3v4.56A4.559,4.559,0,0,0,1309.852,1329.185Zm0-12.164h12.138a4.561,4.561,0,0,0,0-9.121h-12.138a4.561,4.561,0,0,0,0,9.121Z",
    transform: "translate(-1281.027 -1283.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    className: "cls-4",
    d: "M0,1312.56a4.552,4.552,0,1,0,9.1,0V1308H4.552A4.556,4.556,0,0,0,0,1312.56Zm12.138,0v12.162a4.551,4.551,0,1,0,9.1,0v-12.16a4.551,4.551,0,1,0-9.1,0h0",
    transform: "translate(0 -1283.676)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slack.d9d819a866c95db794cc3c945e497e09.svg";